import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula a participação da quantidade pretendida através do percentual de participação sobre a quantidade potencial */
export function calcularParticipacaoQuantidadePretendida(quantidadePotencial: number, percParticipacao: number): number {
    quantidadePotencial = quantidadePotencial && !isNaN(quantidadePotencial) ? Number(quantidadePotencial) : 0;
    percParticipacao = percParticipacao && !isNaN(percParticipacao) ? Number(percParticipacao) : 0;

    const quantidadePretendida = (quantidadePotencial * percParticipacao) / 100;
    return toFixed(quantidadePretendida, 6);
}

/** Calcula o percentual de participação da quantidade pretendida sobre a quantidade potencial */
export function calcularQuantidadePretendidaPerc(quantidadePretendida: number, quantidadePotencial: number): number {
    quantidadePretendida = quantidadePretendida && !isNaN(quantidadePretendida) ? Number(quantidadePretendida) : 0;
    quantidadePotencial = quantidadePotencial && !isNaN(quantidadePotencial) ? Number(quantidadePotencial) : 0;

    if (quantidadePotencial === 0) {
        return 0;
    }

    const perc = (quantidadePretendida / quantidadePotencial) * 100;
    return toFixed(perc, 2);
}

/** Calcula a participação do peso pretendido através do percentual de participação sobre o peso potencial */
export function calcularParticipacaoPesoPretendido(pesoPotencial: number, percParticipacao: number): number {
    pesoPotencial = pesoPotencial && !isNaN(pesoPotencial) ? Number(pesoPotencial) : 0;
    percParticipacao = percParticipacao && !isNaN(percParticipacao) ? Number(percParticipacao) : 0;

    const pesoPretendido = (pesoPotencial * percParticipacao) / 100;
    return toFixed(pesoPretendido, 6);
}

/** Calcula o percentual de participação do peso pretendido sobre o peso potencial */
export function calcularPesoPretendidoPerc(pesoPretendido: number, pesoPotencial: number): number {
    pesoPretendido = pesoPretendido && !isNaN(pesoPretendido) ? Number(pesoPretendido) : 0;
    pesoPotencial = pesoPotencial && !isNaN(pesoPotencial) ? Number(pesoPotencial) : 0;

    if (pesoPotencial === 0) {
        return 0;
    }

    const perc = (pesoPretendido / pesoPotencial) * 100;
    return toFixed(perc, 2);
}

/** Calcula a participação do valor pretendido através do percentual de participação sobre o valor potencial */
export function calcularParticipacaoValorPretendido(valorPotencial: number, percParticipacao: number): number {
    valorPotencial = valorPotencial && !isNaN(valorPotencial) ? Number(valorPotencial) : 0;
    percParticipacao = percParticipacao && !isNaN(percParticipacao) ? Number(percParticipacao) : 0;

    const valorPretendido = (valorPotencial * percParticipacao) / 100;
    return toFixed(valorPretendido, 4);
}

/** Calcula o valor pretendido multiplicando a quantidade pelo valor unitário */
export function calcularValorPretendido(quantidadePretendida: number, valorUnitario: number, precision = 4): number {
    quantidadePretendida = quantidadePretendida && !isNaN(quantidadePretendida) ? Number(quantidadePretendida) : 0;
    valorUnitario = valorUnitario && !isNaN(valorUnitario) ? Number(valorUnitario) : 0;

    const valorPretendido = quantidadePretendida * valorUnitario;
    return toFixed(valorPretendido, precision);
}

/** Calcula o percentual de participação do valor pretendido sobre o valor potencial */
export function calcularValorPretendidoPerc(valorPretendido: number, valorPotencial: number): number {
    valorPretendido = valorPretendido && !isNaN(valorPretendido) ? Number(valorPretendido) : 0;
    valorPotencial = valorPotencial && !isNaN(valorPotencial) ? Number(valorPotencial) : 0;

    if (valorPotencial === 0) {
        return 0;
    }

    const perc = (valorPretendido / valorPotencial) * 100;
    return toFixed(perc, 2);
}
